export default __webpack_public_path__ + "static/media/phoneClear.bd4f2da3.png";